<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('contact.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'contact-information' }">{{ $t('contact.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>{{ $t('contact.detail.heading.contacts') }}</h3>
        <p>
          {{ $t('contact.detail.value.name') }}<br>
          {{ $t('contact.detail.value.address') }}<br>
          {{ $t('contact.detail.label.tax-id-number') }}: {{ $t('contact.detail.value.tax-id-number') }}<br>
          {{ $t('contact.detail.label.telephone') }}: {{ $t('contact.detail.value.telephone') }}<br>
          {{ $t('contact.detail.label.fax') }}: {{ $t('contact.detail.value.fax') }}<br>
          {{ $t('contact.detail.label.fax-hotline-for-dharma-application') }}: {{ $t('contact.detail.value.fax-hotline-for-dharma-application') }}<br>
          {{ $t('contact.detail.label.email') }}: {{ $t('contact.detail.value.email') }}
        </p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>聯絡時間</h3>
        <p>辦公室 星期一至星期五：08:30 ~ 12:00 13:30 ~ 18:00</p>
        <p>
          圖書館（三樓華藏講堂）<br>
          星期一至星期六：08:30 ~ 21:30<br>
          星期日及國定假日：08:30 ~ 18:00
        </p>
        <p>備註：洽商重要事務、申請大量經書法寶，請儘量在週一至週五之平日上班時間。</p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>佛陀教育學院</h3>
        <h5>◎學院相關事宜</h5>
        <p>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 36<br>
          E-mail: <a href="mailto:college@budaedu.org">college@budaedu.org</a>
        </p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>部門組織</h3>
        <h5>1. 法務組</h5>
        <p>
          課務活動相關事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 36<br>
          E-mail: <a href="mailto:doctrin@budaedu.org">doctrin@budaedu.org</a>
        </p>
        <h5>2. 出版部</h5>
        <p>
          經書出版、印刷相關事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 33<br>
          E-mail: <a href="mailto:publish@budaedu.org">publish@budaedu.org</a>
        </p>
        <h5>3. 法寶流通股</h5>
        <p>
          (台灣地區)<br>
          台灣地區經書法寶結緣、流通相關事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 11, 12, 13<br>
          Fax: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-2396-5959（請書專線）<br>
          E-mail: <a href="mailto:domestic@budaedu.org">domestic@budaedu.org</a><br>
          (大陸地區)<br>
          大陸地區經書法寶結緣、流通相關事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 14<br>
          Fax: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-2396-5959（請書專線）<br>
          E-mail: <a href="mailto:mainland@budaedu.org">mainland@budaedu.org</a><br>
          (海外地區)<br>
          海外地區經書法寶結緣、流通相關事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 14<br>
          Fax: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-2396-5959（請書專線）<br>
          E-mail: <a href="mailto:overseas@budaedu.org">overseas@budaedu.org</a>
          (大藏經、海內外大批申請)<br>
          大藏經、海內外大批申請、流通相關事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 14<br>
          Fax : {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-2391-3415<br>
          E-mail: <a href="mailto:dharma@budaedu.org">dharma@budaedu.org</a>
        </p>
        <h5>4. 圖書股</h5>
        <p>
          本會附設圖書館<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 15, 16
        </p>
        <h5>5. 財務股會計</h5>
        <p>
          帳務等事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 42<br>
          E-mail: <a href="mailto:accounting@budaedu.org">accounting@budaedu.org</a>
        </p>
        <h5>6. 社教公益組</h5>
        <p>
          社教公益等事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 12<br>
          E-mail: <a href="mailto:welfare@budaedu.org">welfare@budaedu.org</a>
        </p>
        <h5>7. 資訊組</h5>
        <p>
          電腦系統、網路維護<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 38<br>
          E-mail: <a href="mailto:mis@budaedu.org">mis@budaedu.org</a>
        </p>
        <h5>8. 工程技術股</h5>
        <p>
          電腦系統、網路維護<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 28<br>
          E-mail: <a href="mailto:tec@budaedu.org">tec@budaedu.org</a>
        </p>
        <h5>9. 網站股</h5>
        <p>
          網頁維護<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 23<br>
          E-mail: <a href="mailto:webmaster@budaedu.org">webmaster@budaedu.org</a>
        </p>
        <h5>10. 視訊股</h5>
        <p>
          影片、DVD、MP3製作<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 19<br>
          E-mail: <a href="mailto:video@budaedu.org">video@budaedu.org</a>
        </p>
        <h5>11. 華藏教學園區</h5>
        <p>
          共修活動、課程等相關事宜<br>
          Tel: {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198 分機 12, {{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-26629168<br>
          地址：新北市深坑區阿柔里 5 鄰大崙尾 9 號<br>
          E-mail: <a href="mailto:teachgarden@budaedu.org">teachgarden@budaedu.org</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)
Vue.use(TabsPlugin)

export default {
  i18n,
  name: 'contact-information',
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    this.$i18n.locale = this.$localStorage.get('ui-lang', 'tw')
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('contact.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>